<template>
    <footer>
        <div class="container">
            <div class="row">
                <div class="col-sm-6 offset-sm-3 text-center text-white raleway">
                    <p class="footerText">
                        Copyright &copy; {{ (new Date()).getFullYear() }} Sprintcars.lu | Website made by <a href="http://apps.lu">apps.lu</a>
                    </p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "footerComponent",
    }
</script>

<style>
    p {
        margin: 0 !important;
    }
</style>